<p>square-oauth-callback-component works!</p>
